/***
 *
 *   STATUS BADGE
 *   Thin wrapper around StatusChip. Status keys are dynamic here (per-category
 *   status_template), so unknown keys fall back to the neutral closed tint —
 *   see Chip / StatusChip. Ported from ui-reference status-badge.tsx.
 *
 **********/

import { StatusChip } from 'components/lib';
import { useTranslate } from 'app/translations';
import { STATUS_STYLES } from 'components/chip/chip.tailwind.js';

export { STATUS_STYLES };

export function StatusBadge(props) {
    const { _t } = useTranslate();
    const status = props.status || 'closed';
    const label = props.label || _t(`ticket.category.status.${status}`);

    return (
        <StatusChip
            status={status}
            label={label}
            className={props.className}
        />
    );
}
